import { Checkbox, Radio } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { PropsSelectionCell } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";
import { selectionColWidth } from "src/components/ReactiveTable/constants";
import { AbstractRow } from "src/components/ReactiveTable/RtTypes";

import * as styles from "./common.module.less";

/**
 * Компонент ячейки выбора (чекбокс/радио) в строке таблицы
 */
export const SelectionCell = observer(
  <TRow extends AbstractRow>(props: PropsSelectionCell<TRow>) => {
    const { rowKey, store, isSelected, disabled } = props;
    const { selectionType } = store;
    const Control = selectionType === "checkbox" ? Checkbox : Radio;
    const handleChange = (checked: boolean) => {
      store.changeSelection(rowKey, checked);
    };

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={styles.box}
        onClick={(e) => e.stopPropagation()}
        style={{ width: selectionColWidth }}
      >
        <Control
          checked={isSelected}
          onChange={(e) => handleChange(e.target.checked)}
          disabled={disabled}
        />
      </div>
    );
  },
);
